module.exports = __webpack_public_path__ + "img/talon.36355abe.png";